var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsWordiginsRandomBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a86b18;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.859,89.251A78.272,78.272,0,0,1,71.375,113.4l2.122,2.122,20.7-21.492-1.061-1.061A108.423,108.423,0,0,0,15.124,59.534,14.835,14.835,0,0,0,.265,74.393,14.447,14.447,0,0,0,14.859,89.251Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.617,171.239l-44.311-32.105a8.389,8.389,0,0,0-13.266,6.9v16.981a77.858,77.858,0,0,1-53.863-23.88l-2.123-2.388-20.7,21.492,1.061,1.061a107.029,107.029,0,0,0,75.62,33.167v17.247a8.389,8.389,0,0,0,13.266,6.9l44.311-32.1A8.2,8.2,0,0,0,248.617,171.239Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.04,89.251v16.982a8.389,8.389,0,0,0,13.266,6.9l44.311-32.105a8.457,8.457,0,0,0,0-13.532l-44.311-32.1a8.389,8.389,0,0,0-13.266,6.9V59.534A108.614,108.614,0,0,0,115.42,92.7L71.375,138.869a78.275,78.275,0,0,1-56.516,24.145,14.859,14.859,0,1,0,0,29.717A108.426,108.426,0,0,0,92.867,159.3l44.045-46.168A80.162,80.162,0,0,1,191.04,89.251Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWordiginsRandomBrown);
export default __webpack_public_path__ + "static/media/icons_wordigins_random_brown.b1fbef4ab53da0d2a83fee1e958fc55e.svg";
export { ForwardRef as ReactComponent };